import { defineStore } from "pinia"
import { UITypes } from "@/types"

export const useUIStore = defineStore("ui", {
	state: (): UITypes.UIInterface => {
		return {
			mode: 'light'
		}
	},

	getters: {
		// isAuthenticated: state => !!state.token
	},

	persist: {
		key: "ui",
		storage: window.sessionStorage
	}
})
